export default __webpack_public_path__ + "static/media/equipo-logo_low-res_with-tagline.4581b707.png";